import React from 'react';
import * as XLSX from 'xlsx';
import { getRoStatusName } from "../../utils/common";
const ExportToExcel = ({
  data,
  excludeColumns = ['_id', 'recordStatus'],
  dateColumns = ['roCompletedDate', 'createdAt'],
  columnOrder = ["roNumber", "customerName", "createdAt", "roStatus", "roCompletedDate"],
  headerMapping = { roNumber: "Repair Order#", customerName: "Customer Name", roStatus: "RO Status", createdAt: "Start Date", roCompletedDate: "Completed Date"},
  filename = "Repair-Order-Data.xlsx"
}) => {

  const exportToExcel = (event) => {
    event.preventDefault(); // Prevent form submission
    if (!data || !data.length) return;

    // Step 1: Format dates and filter out excluded columns
    const formattedData = data.map((item) => {
      const formattedItem = {};

      Object.keys(item).forEach((key) => {
        if (!excludeColumns.includes(key)) {
          if (key === "roStatus") {
            // Replace `roStatus` values with new values
            formattedItem[key] = getRoStatusName(item[key]);
          } else if (dateColumns.includes(key) && item[key]) {
            // Format date columns
            formattedItem[key] = new Date(item[key]).toLocaleDateString("en-US", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
            });
          } else {
            formattedItem[key] = item[key];
          }
        }
      });

      return formattedItem;
    });

    // Step 2: Update headers and reorder columns
    const orderedData = formattedData.map((item) => {
      const orderedItem = {};
      columnOrder.forEach((originalKey) => {
        const displayKey = headerMapping[originalKey] || originalKey; // Use mapped header or original key
        orderedItem[displayKey] = item[originalKey]; // Get the value from the original key
      });
      return orderedItem;
    });

    // Step 3: Create a workbook and worksheet with ordered headers
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(orderedData);

    const date = new Date().toISOString().slice(0, 10); // Format: YYYY-MM-DD
    const fileWithDate = `${filename}-${date}.xlsx`;

    // Step 4: Append worksheet to workbook and export
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(workbook, fileWithDate);
  };

  return (
    <button onClick={exportToExcel}>Export to Excel</button>
  );
};

export default ExportToExcel;
